<template>
    <label class="checkbox-button" :for="id" :class="[{ active : value }, { disabled }, { invalid: error }]">
        <div class="checkbox" :class="[{ checked : value }, { disabled }, { invalid: error }]">
            <input type="checkbox"
                   :checked="!!value"
                   :name="id"
                   :id="id"
                   :value="value"
                   :disabled="disabled"
                   @change="update" />
            <span class="square">
                <span class="glyphicon glyphicon-ok"></span>
            </span>
            <slot></slot>
        </div>
    </label>
</template>

<script>
    export default {
        name: 'CheckboxButton',
        props: {
            id: String,
            disabled: Boolean,
            error: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                value: false
            };
        },
        mounted() {
            this.value = this.$attrs.value;
            this.$emit('input', this.$attrs.value);
        },
        methods: {
            update({ target }) {
                this.value = target.checked;
                this.$emit('input', target.checked);
                this.$emit('change', target.checked);
            }
        }
    };
</script>

<style lang="scss">
    .checkbox-button {
        position: relative;
        width: 100%;
        padding: 15px 15px 17px 15px;
        background-color: #f7f7f7;
        border-radius: 4px;
        border: 2px solid transparent;
        cursor: pointer;
        .checkbox {
            margin: 0;
            text-align: center;
            padding-top: 5px;
            padding-left: 30px;
        }

        &:hover,
        &:focus {
            border-color: $brand-colour-primary;
            .checkbox .square {
                border-color: $brand-colour-primary;
            }
        }

        &.active {
            border-color: $brand-colour-primary;
        }

        &.disabled {
            opacity: 0.6;
            cursor: not-allowed;
            border-color: transparent;
        }
    }
</style>
